module.exports = __webpack_public_path__ + "static/media/filter.db506b51.svg";